/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const Jobs: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <G clipPath='url(#clip0_10859_99524)'>
            <Path
                d='M19 5V19H5V5H19ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_10859_99524'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
